import "./navigation.css";
import { useEffect, useRef } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { useRootContext } from "../../hooks/useRootContext";
import NavMenu from "../nav-menu/NavMenu";

function Navigation() {
  const { isNavMenuOpen, setIsNavMenuOpen, setNavHeight, setIsRouteLoading } = useRootContext();

  const navigate = useNavigate();

  const location = useLocation();

  const navigation = useRef(null);

  useEffect(() => {
    if (navigation !== null) {
      setNavHeight(navigation?.current?.offsetHeight);
    } else {
      setNavHeight(0);
    }
  }, [setNavHeight]);

  return (
    <>
      {window.innerWidth > 768 ? (
        <header
          className="navigation"
          onClick={() => {
            if (isNavMenuOpen) setIsNavMenuOpen(false);
          }}
          ref={navigation}
        >
          <div className="nav-first-column">
            <img
              className="nav-brand-logo"
              src="/assets/icons/Timn-Logo.svg"
              alt="TIMN Logo"
              onClick={() => {
                navigate("/");
                setIsNavMenuOpen(false);
                setIsRouteLoading(true);
              }}
            />
            <img
              className="nav-brand"
              src="/assets/icons/Brand-Logo.svg"
              alt="Brand Logo"
              onClick={() => {
                navigate("/");
                setIsNavMenuOpen(false);
                setIsRouteLoading(true);
              }}
            />

            <div className="nav-links">
              <NavLink
                className="nav-link"
                to="/our-work"
                onClick={() => {
                  setIsNavMenuOpen(false);
                  setIsRouteLoading(true);
                }}
              >
                <span>Our Works</span>
                <div className="nav-link-border"></div>
              </NavLink>
              <div
                className={`nav-link ${location.pathname.split("/")[1] === "services" ? "active" : ""
                  }`}
                onClick={() => {
                  setIsNavMenuOpen(!isNavMenuOpen);
                }}
              >
                <span>Services</span>
                <div className="nav-link-border"></div>
              </div>
              <NavLink
                className="nav-link"
                to="/about"
                onClick={() => {
                  setIsNavMenuOpen(false);
                  setIsRouteLoading(true);
                }}
              >
                <span>About Us</span>
                <div className="nav-link-border"></div>
              </NavLink>
            </div>
          </div>

          <div className="nav-second-column">
            <button
              className="send-message-btn"
              onClick={() => {
                navigate("/contact-us");
                setIsRouteLoading(true);
              }}
            >
              Contact Us
            </button>
          </div>
        </header>
      ) : (
        <header
          className="navigation"
          onClick={() => {
            if (isNavMenuOpen) setIsNavMenuOpen(false);
          }}
          ref={navigation}
        >
          <div className="nav-first-column">
            <img
              className="nav-brand-logo"
              src="/assets/icons/Timn-Logo.svg"
              alt="TIMN Logo"
              onClick={() => {
                navigate("/");
                setIsNavMenuOpen(false);
                setIsRouteLoading(true);
              }}
            />
            <img
              className="nav-brand"
              src="/assets/icons/Brand-Logo.svg"
              alt="Brand Logo"
              onClick={() => {
                navigate("/");
                setIsNavMenuOpen(false);
                setIsRouteLoading(true);
              }}
            />
          </div>

          <div className="nav-second-column">
            {isNavMenuOpen ? (
              <svg
                className="navigation-close-btn"
                onClick={() => {
                  setIsNavMenuOpen(false);
                }}
                xmlns="http://www.w3.org/2000/svg" width={26} height={26} viewBox="0 0 26 26" fill="none">
                <rect x="2.25928" y="1.33569" width={32} height={2} transform="rotate(45 2.25928 1.33569)" fill="white" />
                <rect x="0.979004" y="23.6067" width={32} height={2} transform="rotate(-45 0.979004 23.6067)" fill="white" />
              </svg>
            ) : (
              <div
                className="navigation-menu-btn"
                onClick={() => {
                  setIsNavMenuOpen(true);
                }}
              >
                <div className="navigation-menu-btn-line"></div>
                <div className="navigation-menu-btn-line"></div>
              </div>
            )}
          </div>
        </header>
      )}

      <NavMenu />
    </>
  );
}

export default Navigation;